import { Component, Input, OnInit } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { AppointmentDetail } from 'projects/Administration/src/app/business-entities/appointmentDetail-model';
import { AppointmentList } from 'projects/Administration/src/app/business-entities/appointmentList-model';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';

@Component({
  selector: 'app-work-order-vehicle-details',
  templateUrl: './work-order-vehicle-details.component.html',
  styleUrls: ['./work-order-vehicle-details.component.css']
})
export class WorkOrderVehicleDetailsComponent implements OnInit {


  contactDetails: AppointmentDetail;

  @Input() set contactDetail(contactDetails: AppointmentDetail) {
    this.contactDetails = contactDetails;
  }
  
  appointmentDetails: AppointmentList;
  constructor(  
    public editAppointmentService: EditAppointmentService,
    private clipboardApi: ClipboardService
    ) { }

  ngOnInit(): void {
    this.appointmentDetails = this.editAppointmentService.appointmentDetails;
  }

  copyVINText() {
    this.clipboardApi.copyFromContent(this.contactDetails.chassisNo)
  }

}
